import React from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import LocaleStrings from "Languages";

const BetaFeature = (props) => {
  return (
    <OverlayTrigger
      key={`category`}
      placement="right"
      overlay={
        <Tooltip id={`beta-feature`} style={{ marginTop: "-5px" }}>
          <div className="custom-text1-white-normal">
            {LocaleStrings.beta_info_text}
          </div>
        </Tooltip>
      }
    >
      <span className="beta-feature">{LocaleStrings.beta}</span>
    </OverlayTrigger>
  );
};

export default BetaFeature;
